import { Fragment, useEffect } from "react";
import WebFont from "webfontloader";

import ReactDOM from "react-dom";

import Backdrop from "./Backdrop/Backdrop";

import classes from "./Modal.module.css";

// overlay on page that contains card
const ModalOverlay = (props) => {
  return <div className={classes.modal}>{props.children}</div>;
};

const portalElement = document.getElementById("overlays");

const Modal = (props) => {
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Rock Salt"],
      },
    });
  }, []);

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default Modal;
